import { inject, Injectable } from "@angular/core";
import { Actions, ofType, createEffect } from "@ngrx/effects";
import { of } from "rxjs";
import { catchError, map, switchMap } from "rxjs/operators";
import * as subscriptionActions from "./subscription.actions";
import { EmptyAction } from "..";
import { SnackBarService } from "../../services/snackbar.service";
import { Store } from "@ngrx/store";
import { Router } from "@angular/router";
@Injectable()
export class SubscriptionEffects {
    // Inject Services and Actions
    private actions$ = inject(Actions);
    private snackBarService = inject(SnackBarService);
    private store = inject(Store);
    private router = inject(Router);




}
